import React, { FC, useState } from 'react';
import useScrollToSection from '@hooks/useScrollToSection';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import { publicAssets } from '@utils/url.utils';
import ContentWrapper from '../../ui/Content/Content';
import { Wrapper, Background, Section, Image, Reviews, Review, ReviewText, ReviewAuthor, Slider, SliderButton } from './References.elements';

interface ReferencesProps {
    titleKey: string;
    showReferences?: boolean;
    showPartners?: boolean;
}

const ReferencesTemplate: FC<ReferencesProps> = ({ titleKey }) => {
    const { t } = useTranslation();

    const [visibleKey, setVisibleKey] = useState(0);

    useScrollToSection('nasi-partneri', 'partneri');

    const REFERENCES = [
        {
            company: 'HR manažer',
            name: 'Tomáš Klečka',
            comment:
                'Prakticky zaměřené školení s uvedením konkrétních příkladů a doporučení pro zaměstnavatele. Vše probíhá velmi profesionálně v čistých, útulných učebnách a s připraveným občerstvení.',
        },
        {
            company: 'referentka',
            name: 'Jana',
            comment:
                'Naprosto profi kurz. Skvěle připraveno – hlavně příklady z praxe.',
        },
        {
            company: 'zástupkyně vedení',
            name: 'Iveta Cafourková',
            comment:
                'Velmi pozitivní přednáška PaedDr. Štursy, který dokáže zaujmout a upoutat pozornost. Příjemně strávený den.',
        },
        {
            company: 'účetní',
            name: 'Lucie',
            comment:
                'Na kurzech ve Studiu W se mi velmi líbí prostory, pohoštění, ale hlavně náplň a zaujetí přednášejících.',
        },
        {
            company: 'technička',
            name: 'Lucie Kučerová',
            comment:
                'Kurz mě pozitivně naladil. Horší bude informace a dovednosti aplikovat. Výborné vedení pana lektora Štursy.',
        }
    ];

    return (
        <Background>
            <ContentWrapper id="reference" mobileSidePadding={20}>
                <Wrapper>

                    <TitleTemplate tagType={TitleTagTypes.H3} isBlack>
                        {t(titleKey)}
                    </TitleTemplate>

                    <Section>
                        <Image src={publicAssets('/clients.webp')} />
                        <Reviews>
                            {REFERENCES.map((reference, key) => (
                                <Review className={key === visibleKey ? 'isVisible' : 'isHidden'} key={key}>
                                    <ReviewText dangerouslySetInnerHTML={{ __html: reference?.comment }} />
                                    <ReviewAuthor>
                                        {reference?.name} <br /> {reference?.company}
                                    </ReviewAuthor>
                                </Review>
                            ))}
                        </Reviews>
                    </Section>

                    <ContentWrapper mobileSidePadding={20}>
                        <Slider>
                            <SliderButton>
                                <IconTemplate
                                    name={visibleKey > 0 ? Icons.ArrowCircleLeftActive : Icons.ArrowCircleLeftDisabled}
                                    onClick={() => setVisibleKey(visibleKey > 0 ? visibleKey - 1 : 0)}
                                />
                            </SliderButton>
                            <SliderButton>
                                <IconTemplate
                                    name={
                                        visibleKey < REFERENCES.length - 1
                                            ? Icons.ArrowCircleRightActive
                                            : Icons.ArrowCircleRightDisabled
                                    }
                                    onClick={() =>
                                        setVisibleKey(visibleKey < REFERENCES.length - 1 ? visibleKey + 1 : visibleKey)
                                    }
                                />
                            </SliderButton>
                        </Slider>
                    </ContentWrapper>

                </Wrapper>
            </ContentWrapper>
        </Background>
    );
};
export default ReferencesTemplate;
